var exports = {
  "iE": "xaf9ae18d--531ef9--wrapper",
  "Zu": "xaf9ae18d--531ef9--fixed",
  "AS": "xaf9ae18d--531ef9--item",
  "KD": "xaf9ae18d--531ef9--checked",
  "dE": "xaf9ae18d--531ef9--future-type-icon",
};

module.exports = exports;
